import React, { useEffect, useState } from "react";

// Bootstrap
import Card from "react-bootstrap/Card";
import Stack from "react-bootstrap/Stack";
import Badge from "react-bootstrap/Badge";
import { ApiEndpoint } from "../../utils/ApiEndpoint";
import { FormatDateWTime } from "../../utils/FormatData"; // Icons
import * as FiIcons from "react-icons/fi";
import { useAuth } from "../../Context/AuthContext";
import { useQuery } from "@tanstack/react-query";
import { httpClient } from "../../utils/HttpClient";

const Skeleton = () => {
  return (
    <div className="Scroll">
      {Array.from({ length: 5 }).map((_, i) => (
        <Card key={i} className="mb-2">
          <Card.Body>
            <div
              style={{
                width: "60%",
                height: "12px",
                background: "#e2e2e2",
                borderRadius: "4px",
                marginBottom: "10px",
              }}
            />

            <Stack direction="horizontal" gap={2}>
              <div
                style={{
                  width: "80px",
                  height: "12px",
                  background: "#e2e2e2",
                  borderRadius: "4px",
                }}
              />
              <div>·</div>
              <div
                style={{
                  width: "100px",
                  height: "12px",
                  background: "#e2e2e2",
                  borderRadius: "4px",
                }}
              />
              <div className="ms-auto">
                <div
                  style={{
                    width: "70px",
                    height: "12px",
                    background: "#e2e2e2",
                    borderRadius: "4px",
                  }}
                />
              </div>
            </Stack>
          </Card.Body>
        </Card>
      ))}
    </div>
  );
};
function WidgetNextCampaigns() {
  const Auth = useAuth();
  const { token, uid_partner, uid_user } = Auth.getSessionData();
  const [dataReport, setDataReport] = useState(null);

  const { data, isPending, refetch } = useQuery({
    queryKey: ["getSmsData", uid_partner, uid_user],
    queryFn: async () => {
      const response = await httpClient(
        "post",
        `${ApiEndpoint}campaigns/getNextPartnerCampaigns`,
        {
          uidpartner: uid_partner,
          user: uid_user,
        },
        token
      );
      return await response.data;
    },
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    setDataReport(data);
  }, [data]);

  const renderInfo = () => {
    if (isPending) return <Skeleton />;

    if (!dataReport || !dataReport.length)
      return (
        <div className="MessagesSended">
          <div className="flex justify-start items-center gap-2">
            <FiIcons.FiInbox />
            <div className="text-sm">No hay información disponible</div>
          </div>
        </div>
      );

    return (
      <div className="Scroll">
        {dataReport &&
          dataReport.map((sms) => {
            return (
              <Card key={sms.vc_campaignid}>
                <Card.Body>
                  <Card.Text>
                    <Stack direction="horizontal" gap={2}>
                      <div>{sms.vc_campaignname} </div>
                      <div>·</div>
                      <div
                        className="ms-auto"
                        style={{ color: "green", fontWeight: "bold" }}
                      >
                        <span>
                          <Badge bg="success">SMS: {sms.i_records}</Badge>
                        </span>
                      </div>
                    </Stack>
                  </Card.Text>
                  <Stack direction="horizontal" gap={2}>
                    <div>
                      <span>Mensaje: {sms.vc_message}</span>
                    </div>
                    <div>·</div>
                    <div
                      className="ms-auto"
                      style={{ color: "green", fontWeight: "bold" }}
                    >
                      <span>{FormatDateWTime(sms.tst_send)}</span>
                    </div>
                  </Stack>
                </Card.Body>
              </Card>
            );
          })}
      </div>
    );
  };

  return (
    <>
      <div className="MessagesSended">
        <Stack direction="horizontal" gap={2}>
          <h6>Proximas Campañas Programadas</h6>
          <div className="ms-auto cursor-pointer bg-gray-100 hover:bg-gray-300 w-10 h-10 flex items-center justify-center rounded-lg">
            <FiIcons.FiRefreshCw onClick={refetch} />
          </div>
        </Stack>
        {renderInfo()}
        {/* <div className="details">
            <Link to="/Reports/ReportDate">Ver detalles</Link>
          </div> */}
      </div>
    </>
  );
}

export default WidgetNextCampaigns;
